import React, { FC } from 'react';
import { PlcContentLoader } from '@components/Loaders/PlcContentLoader.component';
import { PlcTextListLoader, PlcTextLoader } from '@components/Loaders/PlcTextLoader.component';
import { TextAreaLoader } from '@components/Loaders/TextAreaLoader.component';
import { Spacing } from '@styles/Spacing.style';
import { TextStyle } from '@styles/Text.style';

export const SingleCommentLoader: FC<{ uniqueKey: string }> = ({ uniqueKey }) => {
  return (
    <PlcTextListLoader
      textProps={[
        { bottomSpacing: Spacing.s, variant: 'h6', width: 70 },
        { bottomSpacing: Spacing.s, variant: 'h4', width: 139 },
        {
          bottomSpacing: Spacing.m,
          numberOfLine: 3,
          variant: 'small',
          width: 350,
        },
      ]}
      uniqueKey={uniqueKey}
      width={400}
    />
  );
};

const CommentHeaderLoader: FC<{ uniqueKey: string }> = ({ uniqueKey }) => {
  return (
    <PlcContentLoader height={TextStyle.h3.lineHeight + Spacing.m + 250 + Spacing.m} uniqueKey={uniqueKey} width={400}>
      <PlcTextLoader variant="h3" width={230} />
      <TextAreaLoader width={400} y={TextStyle.h3.lineHeight + Spacing.m} />
    </PlcContentLoader>
  );
};

export const CommentsListLoader: FC<{}> = () => {
  return (
    <>
      <CommentHeaderLoader uniqueKey="commentHeader-1" />
      <SingleCommentLoader uniqueKey="singleComment-1" />
      <SingleCommentLoader uniqueKey="singleComment-2" />
    </>
  );
};
